"use client";

import { Suspense, useEffect, useRef, useState } from "react";
import { usePathname, useSearchParams } from "next/navigation";

function RouteProgressInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [visible, setVisible] = useState(false);
  const [width, setWidth] = useState(0);
  const firstRender = useRef(true);
  const routeKey = `${pathname}?${searchParams.toString()}`;

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    setVisible(true);
    setWidth(8);
    const raf = window.setInterval(
      () => setWidth((w) => (w < 90 ? w + Math.max(0.6, (90 - w) / 14) : w)),
      120,
    );
    const done = window.setTimeout(() => {
      setWidth(100);
      window.setTimeout(() => {
        setVisible(false);
        setWidth(0);
      }, 320);
    }, 260);
    return () => {
      clearInterval(raf);
      clearTimeout(done);
    };
  }, [routeKey]);

  if (!visible) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[200] h-0.5" aria-hidden>
      <div
        className="h-full bg-gradient-to-l from-primary via-secondary-main to-primary shadow-[0_0_10px_rgba(0,150,136,0.7)] transition-[width] duration-200 ease-out"
        style={{ width: `${width}%` }}
      />
    </div>
  );
}

export default function RouteProgress() {
  return (
    <Suspense fallback={null}>
      <RouteProgressInner />
    </Suspense>
  );
}
